import React from "react";
import phone1 from "../../Images/HONOR-X9a.jpg";

const phones = [
  {
    img: phone1,
    name: "HONOR X9a 5G Smartphone (8GB+256GB)- Silver Color (Official)",
    price: "36500",
    listPrice: " 36999",
    description:
      " 01-Year warranty (Must Claim with box and accessories to Honor Customer Care) The HONOR X9a 5G Smartphone (8GB+256GB) is a mid-range smartphone that offers a great all-around experience at an affordable price. It has a sleek and stylish design, a powerful octa-core processor, a long-lasting battery, and a versatile triple-lens camera setup. The phone also supports 5G connectivity, so you can take advantage of the latest mobile network speeds.Here are some of the key features of the HONOR X9a 5G Smartphone (8GB+256GB): 6.67-inch AMOLED display with a 120Hz refresh rate, Qualcomm Snapdragon 695 5G octa-core processor, 8GB of RAM, 256GB of storage, 5100mAh battery, Android 12 operating system, 64MP triple-lens rear camera, 16MP front-facing camera, Dual SIM support, 5G connectivity, Wi-Fi 6 connectivity, Bluetooth 5.1 connectivity, USB Type-C port,Side-mounted fingerprint sensor ",
  },
];

const DailyD = () => {
  return (
    <div className="text-justify md:px-20 px-5 text-accent">
      <h2 className="text-center pt-10 lg:text-5xl text-3xl font-bold mb-5">
        {" "}
        Today's Best Deals
      </h2>
      <div
        className="text-center  bg-base-100 border-2 mb-20 rounded text-black"
        style={{ fontFamily: "Roboto" }}
      >
        {phones.map((phone, index) => (
          <div key={index}>
            <figure className="pt-6">
              <img
                className="h-80 w-80 hover:scale-110 hover:duration-500 mx-auto "
                src={phone.img}
                alt="Shoes"
              />
            </figure>
            <div className="my-10 md:mx-10 mx-2">
              <h2 className="text-sm text-center md:font-bold">{phone.name}</h2>
              <p className="text font-bold text-primary">
                Price: {phone.price} Tk
                <span className="line-through text-gray-400 text-right ml-3">
                  list price: {phone.listPrice} Tk
                </span>
              </p>
              <p className="text-justify ">{phone.description}..</p>
              <div className="justify-end mt-5">
                <a
                  className="text-decoration-none text-primary"
                  href="https://api.whatsapp.com/send?phone=1754675993"
                >
                  <button className="btn border-2 border-white btn-block bg-gradient-to-r from-secondary-400 to-primary-500 hover:from-green-500 hover:to-blue-500 text-accent">
                    Buy Now
                  </button>{" "}
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div>
        <p>Comming soon..</p>
        <p>
          Key Features: Fresh Arrivals: Explore the latest products that have
          just landed on Mbaba. From cutting-edge gadgets to fashion-forward
          styles, this section is a showcase of what's new and trending. Limited
          Editions: Discover exclusive and limited-edition items that add a
          touch of uniqueness to your shopping experience. Act fast, as these
          treasures are available in limited quantities. Exclusive Finds:
          Uncover hidden gems and one-of-a-kind items that you won't find
          anywhere else. "Daily Delights" is your go-to destination for products
          that stand out from the crowd. Curated Selection: Our team carefully
          curates a selection of products each day, ensuring that you get the
          best and most exciting finds. It's a handpicked collection designed to
          bring joy to your daily browsing. Surprise Element: The "Daily
          Delights" section is designed to be a delightful surprise every time
          you visit Mbaba. You never know what extraordinary product might be
          featured, adding an element of excitement to your shopping routine.
          Why Explore "Daily Delights"? Stay Trendy: Be at the forefront of
          trends with daily updates on the latest and hottest products in the
          market. Unique Finds: If you love discovering unique and exclusive
          items, this section is tailored for you. "Daily Delights" is where
          rarity meets everyday shopping. Fresh Inspiration: Whether you're
          looking for inspiration or simply want to treat yourself, "Daily
          Delights" provides a daily source of inspiration for your shopping
          journey. Community Interaction: Engage with the Mbaba community by
          sharing your thoughts and experiences with the featured products.
          Connect with fellow enthusiasts who appreciate the joy of daily
          discoveries. Explore "Daily Delights" and turn each day into a new
          adventure of shopping and discovery on Mbaba! 🌈🛍️
        </p>
      </div>
    </div>
  );
};

export default DailyD;
